import React, { useEffect, useState } from "react";

import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

import api from "../../../configs/api";
import Loader from "../../../common/Loader";

import Swal from "sweetalert2";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import { Alert, Tooltip } from "@mui/material";
import CustomPagination from "../../ui/Pagination";

export default function Table({
  handleModal,
  setIsDelete,
  rows,
  search,
  searchType,
  itemsPerPage,
  setIdUserForDelete,
  status,
  setStatus,
  searchAction,
  setSearchAction,
}) {
  const [loading, setLoading] = useState(false);

  const [totalItems, setTotalItems] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [users, setUsers] = useState([]);

  const handleNextPage = (event, value) => {
    setCurrentPage(value);
  };

  const handleDelete = (id) => {
    handleModal(setIsDelete, true);
    setIdUserForDelete(id);
  };

  const handleApprove = async (id) => {
    setLoading(true);

    try {
      await api.put(`admin/approve_specialist/${id}`, { Approved: true });

      Swal.fire({
        position: "center",
        icon: "success",
        title: "The user has been approved successfully",
        showConfirmButton: false,
        timer: 5000,
      });
      getSpecialists(currentPage);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);

      Swal.fire({
        position: "center",
        icon: "error",
        title: "something went wrong, please try again later",
        showConfirmButton: false,
        timer: 5000,
      });
      setLoading(false);
    }
  };

  async function getSpecialists(page) {
    setLoading(true);

    try {
      const res = await api.get(
        `admin/get_all_specialists?page=${page}&pageSize=${itemsPerPage}&approved=false`,
      );

      setUsers(res.data.specialists);
      setTotalItems(res.data.totalPages);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  }

  async function searchFoSpecialists(page) {
    setLoading(true);
    try {
      const res = await api.get(
        `/admin/admin_search?documentName=specialist&fieldName=${searchType}&value=${search}&page=${page}&pageSize=${itemsPerPage}&approved=false`,
      );

      setUsers(res.data.users);
      setTotalItems(res.data.totalPages);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (searchType && search) {
      searchFoSpecialists(currentPage);
    } else if (!searchType && !search) {
      getSpecialists(currentPage);
    }
    setSearchAction(false);
  }, [searchAction, currentPage]);

  useEffect(() => {
    if (status.show) {
      Swal.fire({
        position: "center",
        icon: status.icon,
        title: status.title,
        showConfirmButton: status.showConfirmButton,
        timer: status.timer,
      });
      getSpecialists(currentPage);
    }
    setStatus(false);
  }, [status]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <div className='flex flex-col rounded-lg'>
        <div className='overflow-x-auto'>
          <div className='inline-block min-w-full align-middle'>
            <div className='overflow-hidden shadow'>
              <h1 className='bg-[#f5f5f5] p-4 text-xl'>Users Approved List</h1>
              {users.length <= 0 && (
                <Alert severity='info'>There are no users!</Alert>
              )}
              <table className='min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-600'>
                <thead className='bg-white dark:bg-gray-700'>
                  <tr>
                    {rows?.map((row) => {
                      return (
                        <th
                          scope='col'
                          className='p-4 text-xs font-medium text-left  uppercase text-primary'
                        >
                          {row}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody className='bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700'>
                  {users?.map((row) => {
                    return (
                      <tr className='hover:bg-gray-100 dark:hover:bg-gray-700'>
                        <td className='flex items-center p-3 mr-12 space-x-6 whitespace-nowrap'>
                          <img
                            alt='user'
                            className='w-10 h-10 rounded-full'
                            src={row?.image  || "global_Images/user.png"}
                          />
                          <div className='text-sm font-normal text-gray-500 dark:text-gray-400'>
                            <div className='text-base font-semibold text-gray-900 dark:text-white'>
                              {row.fullName}
                            </div>
                            <div className='text-sm font-normal text-gray-500 dark:text-gray-400'>
                              {row.email}
                            </div>
                          </div>
                        </td>
                        <td className='break-words p-3 text-base font-medium text-gray-900 whitespace-nowrap dark:text-white'>
                          {row.phone}
                        </td>
                        <td className='break-words p-3 text-base font-medium text-gray-900 whitespace-nowrap dark:text-white'>
                          {row.city}
                        </td>
                        <td className='break-words p-3 text-base font-medium text-gray-900 whitespace-nowrap dark:text-white'>
                          {row.district}
                        </td>
                        <td className='break-words p-3 text-base font-medium text-gray-900 whitespace-nowrap dark:text-white'>
                          {row.degree}
                        </td>
                        <td className='break-words p-3 text-base font-medium text-gray-900 whitespace-nowrap dark:text-white'>
                          {row.specialization}
                        </td>
                        <td className='break-words p-3 text-base font-medium text-gray-900 whitespace-nowrap dark:text-white'>
                          {row.yearsOfExperience}
                        </td>
                        <td className='break-words p-3 text-base font-medium text-gray-900 whitespace-nowrap dark:text-white'>
                          {row.gender}
                        </td>
                        <td>
                          <td className='p-4 space-x-2 whitespace-nowrap'>
                            <Tooltip title='Accept'>
                              <button
                                onClick={() => handleApprove(row._id)}
                                type='button'
                                data-modal-toggle='delete-usefr-modal'
                                className='inline-flex items-center px-3 py-3 rounded-full text-sm font-medium text-center text-white bg-[#7CF05269]  hover:bg-[#7CF052] focus:ring-4 focus:ring-green-300 '
                              >
                                <AiOutlineCheck className='text-[#2FA901] text-xl' />
                              </button>
                            </Tooltip>
                            <Tooltip title='Reject'>
                              <button
                                onClick={() => handleDelete(row._id)}
                                type='button'
                                data-modal-toggle='delete-user-modal'
                                className='inline-flex items-center px-3 py-3 text-sm font-medium text-center text-white bg-[#FF56568C] rounded-full hover:bg-[#FF5656] focus:ring-4 focus:ring-red-300'
                              >
                                <AiOutlineClose className='text-xl text-red-600' />
                              </button>
                            </Tooltip>
                          </td>
                        </td>
                        <td className='p-3 text-base font-medium text-gray-900 whitespace-normal max-w-xs dark:text-white'>
                          <div
                            className='truncate overflow-hidden'
                            title={row.brief}
                          >
                            {row.brief}
                          </div>
                        </td>
                        <td className='p-3 text-base font-medium text-gray-900 whitespace-nowrap dark:text-white'>
                          <a className="text-blue-700" target="_blank" rel="noreferrer" key={row?.resume} href={row?.resume}>Resume</a>
                        </td>
                        <td className='p-3 text-base font-medium text-gray-900 whitespace-nowrap dark:text-white'>
                          <a className="text-blue-700" target="_blank" rel="noreferrer" key={row?.graduationCertificate} href={row?.graduationCertificate}>Graduation Certificate</a>
                        </td>
                        <td className='p-3 text-base font-medium text-gray-900 whitespace-nowrap dark:text-white'>
                          <a className="text-blue-700" target="_blank" rel="noreferrer" key={row?.ID_card} href={row?.ID_card}>Card ID</a>
                        </td>
                        <td className='p-4 text-base font-medium text-gray-900 whitespace-nowrap dark:text-white'>
                          {row.createdAt.split("T")[0]}
                        </td>
                        <td className='p-4 text-base font-medium text-gray-900 whitespace-nowrap dark:text-white'>
                          {row.updatedAt.split("T")[0]}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <CustomPagination
          totalItems={totalItems}
          currentPage={currentPage}
          handleNextPage={handleNextPage}
        />
      </div>
    </div>
  );
}
